var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-btn",
    _vm._g(
      _vm._b(
        {
          attrs: { text: "", color: _vm.color, small: _vm.small },
          on: {
            click: function ($event) {
              return _setup.emit("clicked", $event)
            },
          },
        },
        "v-btn",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    ),
    [
      _vm._t("icon-left"),
      _vm._v(" " + _vm._s(_vm.label) + " "),
      _vm._t("icon-right"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }